import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { getUrlHashForCurrentTitleNode } from '../../controllers/cursorFollowsURL'
import { ImportExport } from './ImportExport'
import { LoginLogout } from './LoginLogout'

export const Settings = () => {
    useEffect(() => {
        document.title = 'Treelist – Settings'
    }, [])

    const hash = getUrlHashForCurrentTitleNode()

    return (
        <>
            <div id="titleview">
                <NavLink className="titleview-item" activeClassName="titleview-item-active" exact to={'/' + hash}>
                    <i className="fal fa-times"></i>
                </NavLink>
                <h1>Settings</h1>
            </div>
            <div id="pageview">
                <ImportExport />
                <br />
                <h2>Sync (not yet functional)</h2>
                <LoginLogout />
                <div id="user"></div>
            </div>
        </>
    )
}